import React from 'react';

import Tooltip from './Tooltip';
import { notEmpty } from '@javascript/util.js';

const FormLabel = ({
  label,
  klass,
  spanKlass,
  htmlFor,
  children,
  required,
  tooltip,
  mobileSubLabel,
}) => (
  <label htmlFor={htmlFor} className={klass}>
    {
      label.length > 0 && (
        <span className={spanKlass ? `label-text ${spanKlass}` : 'label-text'}>
          {label}
          {required && <span className="required">*</span>}
          {tooltip && <Tooltip tip={tooltip} />}
          {notEmpty(mobileSubLabel) && <div className="sub-label">{mobileSubLabel}</div>}
        </span>
      )
    }
    {children}
  </label>
);

export default FormLabel;
